import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React from "react";
import { CSSProperties } from "react";
import styles from "./_loading-indicator.module.scss";
import classNames from 'classnames';
export interface LoadingIndicatorProps {
  style?: CSSProperties;
  className?: string;
  label: React.ReactNode;
  size?: 'small' | 'large';
}

export default function LoadingIndicator(props: LoadingIndicatorProps) {
  return (
    <div className={classNames(styles.loadingIndicatorContainer, props.className, props.size === 'small' 
      ? styles.small 
      : undefined)} 
      style={props.style}>
      <Typography variant={props.size === 'small' ? 'h6' : 'h4'} style={props.size === 'small' ? { marginLeft: "5px" } : { marginBottom: "5px" }}>
        {props.label}
      </Typography>
      <CircularProgress size={props.size === 'small' ? '15px' : undefined} />
    </div>
  );
}
